(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5782],{

/***/ 47492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(68777);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22546);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(68312);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9846);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13390);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50067);
/* harmony import */ var _home_ImgP__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13810);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(31555);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(62642);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30653);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85893);




















var Title = next_dynamic__WEBPACK_IMPORTED_MODULE_10___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 93264));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(93264)];
    }
  }
});
var ButtonNoLink = next_dynamic__WEBPACK_IMPORTED_MODULE_10___default()(function () {
  return __webpack_require__.e(/* import() */ 265).then(__webpack_require__.bind(__webpack_require__, 70265));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(70265)];
    }
  }
});
var Button = next_dynamic__WEBPACK_IMPORTED_MODULE_10___default()(function () {
  return __webpack_require__.e(/* import() */ 7911).then(__webpack_require__.bind(__webpack_require__, 77911));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(77911)];
    }
  }
});

var Banner = function Banner(_ref) {
  var _data$posts, _feature_data$posts;

  var data = _ref.data,
      offset = _ref.offset,
      feature_data = _ref.feature_data,
      windowWidth = _ref.windowWidth;
  var banner_data = (data === null || data === void 0 ? void 0 : (_data$posts = data.posts) === null || _data$posts === void 0 ? void 0 : _data$posts.list) || [];
  var feature_box = feature_data === null || feature_data === void 0 ? void 0 : (_feature_data$posts = feature_data.posts) === null || _feature_data$posts === void 0 ? void 0 : _feature_data$posts.list; // const slider_data = data?.posts?.list?.[0]?.find(f => f?.images?.banner === 'on') ;

  var swiperRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var swiperRefTwo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null); // handle slider progress

  var handleProgress = function handleProgress(swiper) {
    var interleaveOffset = 0.5;

    for (var i = 0; i < swiper.slides.length; i++) {
      var slideProgress = swiper.slides[i].progress;
      var innerOffset = swiper.width * interleaveOffset;
      var innerTranslate = slideProgress * innerOffset;
      swiper.slides[i].querySelector(".global-image").style.transform = "translate3d(" + innerTranslate + "px, 0, 0)";
    }
  }; // hand touch move not required this slider


  var handleTouchStart = function handleTouchStart(swiper) {
    for (var i = 0; i < swiper.slides.length; i++) {
      swiper.slides[i].style.transition = "";
    }
  }; // handle image transition on change


  var handleSetTransition = function handleSetTransition(swiper, speed) {
    for (var i = 0; i < swiper.slides.length; i++) {
      swiper.slides[i].style.transition = "".concat(speed, "ms");
      swiper.slides[i].querySelector(".global-image").style.transition = "".concat(speed, "ms");
    }
  }; // handle pagination


  var pagination_title = ['Financial freedom at the palm of your hands', 'Investing in growth to open new big opportunities', 'Financial freedom at the palm of your hands', 'Investing in growth to open new big opportunities'];
  var pagination = {
    clickable: true,
    renderBullet: function renderBullet(index, className) {
      return '<div class="' + className + '"><span>' + pagination_title[index] + "</span></div>";
    }
  };

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      activeSlideIndex = _useState[0],
      setActiveSlideIndex = _useState[1];

  var handleSlideChange = function handleSlideChange(event) {
    var newActiveSlideIndex = event.realIndex;
    setActiveSlideIndex(newActiveSlideIndex);

    if (swiperRefTwo.current) {
      swiperRefTwo.current.swiper.slideTo(newActiveSlideIndex);
    }
  };

  var handleButtonClickPagination = function handleButtonClickPagination(index) {
    if (swiperRef.current) {
      setActiveSlideIndex(index);
      swiperRef.current.swiper.slideToLoop(index);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var swiper = swiperRef.current;
    var autoplayDelay = 5000; // Delay in milliseconds before autoplaying

    var autoplayTimeout = setTimeout(function () {
      if (swiper && swiper.autoplay) {
        swiper.autoplay.start();
      }
    }, autoplayDelay);
    return function () {
      clearTimeout(autoplayTimeout);
    };
  }, []);

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      show = _useState2[0],
      setShow = _useState2[1];

  var handleClose = function handleClose() {
    return setShow(false);
  };

  var handleShow = function handleShow(e) {
    setShow(true);
  };

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isModalVisible = _useState3[0],
      setIsModalVisible = _useState3[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTimeout(function () {
      setIsModalVisible(true);
    }, 1500);
  }, [isModalVisible]);
  var location = (0,next_router__WEBPACK_IMPORTED_MODULE_11__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // Use GSAP to animate opacity from 0 to 1
    gsap__WEBPACK_IMPORTED_MODULE_14__/* .gsap.to */ .p8.to('.hide', {
      alpha: 1,
      visibility: 'visible',
      display: 'block',
      duration: 0.5,
      delay: 1
    });
    gsap__WEBPACK_IMPORTED_MODULE_14__/* .gsap.to */ .p8.to('.hide-title', {
      alpha: 1,
      visibility: 'visible',
      display: 'block',
      duration: 0.5,
      delay: 1
    });
  }, [location.pathname, data]); // Run this effect only once when the component mounts

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var sectionTop = document.querySelector('.home-banner').offsetTop;
    window.addEventListener('scroll', function () {
      if (window.pageYOffset >= sectionTop) {
        // swiperScroll.current.autoplay.stop()
        setTimeout(function () {
          var _swiperRef$current, _swiperRef$current$sw;

          swiperRef === null || swiperRef === void 0 ? void 0 : (_swiperRef$current = swiperRef.current) === null || _swiperRef$current === void 0 ? void 0 : (_swiperRef$current$sw = _swiperRef$current.swiper) === null || _swiperRef$current$sw === void 0 ? void 0 : _swiperRef$current$sw.autoplay.start();
        }, 300);
      }
    });
  }, [banner_data]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledBanner, {
      offset: offset,
      className: 'home-banner ',
      children: [banner_data && (banner_data === null || banner_data === void 0 ? void 0 : banner_data.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq, {
        ref: swiperRef,
        spaceBetween: 0,
        loop: true,
        autoplay: true,
        speed: "2500",
        onSlideChange: handleSlideChange,
        onProgress: handleProgress,
        touchStart: handleTouchStart,
        onSetTransition: handleSetTransition,
        grabCursor: false,
        lazy: true,
        watchSlidesProgress: true,
        mousewheelControl: true,
        keyboardControl: true,
        navigation: {
          prevEl: '#banner-prev',
          nextEl: '#banner-next'
        },
        pagination: pagination,
        modules: [swiper__WEBPACK_IMPORTED_MODULE_7__/* .Autoplay */ .pt, swiper__WEBPACK_IMPORTED_MODULE_7__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_7__/* .Navigation */ .W_],
        sName: "mySwiper main-swiper",
        children: banner_data && (banner_data === null || banner_data === void 0 ? void 0 : banner_data.length) > 0 && (banner_data === null || banner_data === void 0 ? void 0 : banner_data.map(function (e, index) {
          var _e$images, _e$images$, _e$images$2, _e$images$3, _e$images$4, _e$images$5, _e$images$6, _e$data, _e$data2, _e$data3, _e$data4, _e$data5, _e$data6, _e$data7, _e$data8, _e$data9, _e$data10, _e$data11, _e$data12, _e$data13;

          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
              className: "slide-inner",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                className: "desktop",
                children: windowWidth > 767 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_home_ImgP__WEBPACK_IMPORTED_MODULE_8__/* .Img */ .E, {
                  alt: 'Shanta Securities Limited',
                  src: e !== null && e !== void 0 && (_e$images = e.images) !== null && _e$images !== void 0 && (_e$images$ = _e$images[0]) !== null && _e$images$ !== void 0 && _e$images$.full_path ? e === null || e === void 0 ? void 0 : (_e$images$2 = e.images[0]) === null || _e$images$2 === void 0 ? void 0 : _e$images$2.full_path : '/images/static/blur.jpg'
                }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_home_ImgP__WEBPACK_IMPORTED_MODULE_8__/* .Img */ .E, {
                  alt: 'Shanta Securities Limited',
                  src: e !== null && e !== void 0 && (_e$images$3 = e.images[1]) !== null && _e$images$3 !== void 0 && _e$images$3.full_path ? e === null || e === void 0 ? void 0 : (_e$images$4 = e.images[1]) === null || _e$images$4 === void 0 ? void 0 : _e$images$4.full_path : e !== null && e !== void 0 && (_e$images$5 = e.images[0]) !== null && _e$images$5 !== void 0 && _e$images$5.full_path ? e === null || e === void 0 ? void 0 : (_e$images$6 = e.images[0]) === null || _e$images$6 === void 0 ? void 0 : _e$images$6.full_path : '/images/static/blur.jpg'
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
                      className: "slide-inner__info",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                        className: "hide-title",
                        children: index == 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("h1", {
                          children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(e === null || e === void 0 ? void 0 : (_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.short_desc)
                        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("h2", {
                          children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(e === null || e === void 0 ? void 0 : (_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.short_desc)
                        })
                      }), (e === null || e === void 0 ? void 0 : (_e$data3 = e.data) === null || _e$data3 === void 0 ? void 0 : _e$data3.button_url) !== 'investor_calculator' ? (e === null || e === void 0 ? void 0 : (_e$data4 = e.data) === null || _e$data4 === void 0 ? void 0 : _e$data4.button_new_tab) === 'Y' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(Button, {
                        newtablink: e === null || e === void 0 ? void 0 : (_e$data5 = e.data) === null || _e$data5 === void 0 ? void 0 : _e$data5.button_url,
                        target: '_blank',
                        "data-lag": '0.2',
                        margin: '40px 0 0',
                        text: e !== null && e !== void 0 && (_e$data6 = e.data) !== null && _e$data6 !== void 0 && _e$data6.subtitle ? e === null || e === void 0 ? void 0 : (_e$data7 = e.data) === null || _e$data7 === void 0 ? void 0 : _e$data7.subtitle : 'Open an Account Now',
                        hoverBackground: '#004195',
                        borderColor: '#004195',
                        color: '#FFFFFF',
                        fontSize: '16px',
                        lineHeight: '20px',
                        fontWeight: '400',
                        letterSpacing: '0'
                      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(Button, {
                        src: e === null || e === void 0 ? void 0 : (_e$data8 = e.data) === null || _e$data8 === void 0 ? void 0 : _e$data8.button_url,
                        target: '_blank',
                        "data-lag": '0.2',
                        margin: '40px 0 0',
                        text: e !== null && e !== void 0 && (_e$data9 = e.data) !== null && _e$data9 !== void 0 && _e$data9.subtitle ? e === null || e === void 0 ? void 0 : (_e$data10 = e.data) === null || _e$data10 === void 0 ? void 0 : _e$data10.subtitle : 'Open an Account Now',
                        hoverBackground: '#004195',
                        borderColor: '#004195',
                        color: '#FFFFFF',
                        fontSize: '16px',
                        lineHeight: '20px',
                        fontWeight: '400',
                        letterSpacing: '0'
                      }) : (e === null || e === void 0 ? void 0 : (_e$data11 = e.data) === null || _e$data11 === void 0 ? void 0 : _e$data11.button_url) === 'investor_calculator' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                        onClick: function onClick() {
                          return handleShow();
                        },
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(ButtonNoLink, {
                          nolink: true,
                          "data-lag": '0.2',
                          margin: '40px 0 0',
                          text: e !== null && e !== void 0 && (_e$data12 = e.data) !== null && _e$data12 !== void 0 && _e$data12.subtitle ? e === null || e === void 0 ? void 0 : (_e$data13 = e.data) === null || _e$data13 === void 0 ? void 0 : _e$data13.subtitle : 'Open an Account Now',
                          hoverBackground: '#004195',
                          borderColor: '#004195',
                          color: '#FFFFFF',
                          fontSize: '16px',
                          lineHeight: '20px',
                          fontWeight: '400',
                          letterSpacing: '0'
                        })
                      }) : '']
                    })
                  })
                })
              })]
            })
          }, index);
        }))
      }) : '', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
        className: "swipper-navigation-slider-custom",
        children: banner_data && (banner_data === null || banner_data === void 0 ? void 0 : banner_data.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq, {
          ref: swiperRefTwo,
          speed: "1000",
          slidesPerView: 4,
          spaceBetween: 30,
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 30
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 30
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 30
            }
          },
          modules: [swiper__WEBPACK_IMPORTED_MODULE_7__/* .Autoplay */ .pt, swiper__WEBPACK_IMPORTED_MODULE_7__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_7__/* .Navigation */ .W_],
          className: "mySwiperNext",
          children: banner_data && (banner_data === null || banner_data === void 0 ? void 0 : banner_data.length) > 0 && (banner_data === null || banner_data === void 0 ? void 0 : banner_data.map(function (e, index) {
            var _e$data14;

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                className: "slide-inner-item ".concat(activeSlideIndex === index ? 'active' : '', " "),
                onClick: function onClick() {
                  return handleButtonClickPagination(index);
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("span", {
                  children: e === null || e === void 0 ? void 0 : (_e$data14 = e.data) === null || _e$data14 === void 0 ? void 0 : _e$data14.title
                })
              })
            }, index);
          }))
        }) : ''
      }), banner_data && (banner_data === null || banner_data === void 0 ? void 0 : banner_data.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
        className: "navigation",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("ul", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("li", {
                  id: 'banner-next',
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "44",
                    height: "44",
                    viewBox: "0 0 44 44",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                      id: "Next",
                      transform: "translate(16429 -2014)",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                        id: "Rectangle_492",
                        "data-name": "Rectangle 492",
                        transform: "translate(-16429 2014)",
                        fill: "none",
                        stroke: "#fff",
                        strokeWidth: "1",
                        opacity: "0.5",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("rect", {
                          width: "44",
                          height: "44",
                          rx: "22",
                          stroke: "none"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("rect", {
                          x: "0.5",
                          y: "0.5",
                          width: "43",
                          height: "43",
                          rx: "21.5",
                          fill: "none"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                        id: "Group_4824",
                        "data-name": "Group 4824",
                        transform: "translate(-17065.5 434.5)",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                          id: "Group_4823",
                          "data-name": "Group 4823",
                          transform: "translate(11 4)",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("line", {
                            id: "Line_9",
                            "data-name": "Line 9",
                            x2: "5",
                            y2: "5",
                            transform: "translate(647.5 1592.5)",
                            fill: "none",
                            stroke: "#fff",
                            strokeLinecap: "round",
                            strokeWidth: "1"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("line", {
                            id: "Line_10",
                            "data-name": "Line 10",
                            x1: "5",
                            y2: "5",
                            transform: "translate(647.5 1597.5)",
                            fill: "none",
                            stroke: "#fff",
                            strokeLinecap: "round",
                            strokeWidth: "1"
                          })]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("line", {
                          id: "Line_11",
                          "data-name": "Line 11",
                          x2: "10",
                          transform: "translate(653.5 1601.5)",
                          fill: "none",
                          stroke: "#fff",
                          strokeLinecap: "round",
                          strokeWidth: "1"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                        id: "Rectangle_5661",
                        "data-name": "Rectangle 5661",
                        transform: "translate(-16429 2058) rotate(-90)",
                        fill: "none",
                        stroke: "#fff",
                        strokeWidth: "1",
                        strokeDasharray: "0",
                        opacity: "0",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("rect", {
                          width: "44",
                          height: "44",
                          rx: "22",
                          stroke: "none"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("rect", {
                          x: "0.5",
                          y: "0.5",
                          width: "43",
                          height: "43",
                          rx: "21.5",
                          fill: "none"
                        })]
                      })]
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("li", {
                  id: 'banner-prev',
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("svg", {
                    id: "Prev",
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "44",
                    height: "44",
                    viewBox: "0 0 44 44",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                      id: "Rectangle_492",
                      "data-name": "Rectangle 492",
                      fill: "none",
                      stroke: "#fff",
                      strokeWidth: "1",
                      opacity: "0.5",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("rect", {
                        width: "44",
                        height: "44",
                        rx: "22",
                        stroke: "none"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("rect", {
                        x: "0.5",
                        y: "0.5",
                        width: "43",
                        height: "43",
                        rx: "21.5",
                        fill: "none"
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                      id: "Group_4824",
                      "data-name": "Group 4824",
                      transform: "translate(17 17)",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                        id: "Group_4823",
                        "data-name": "Group 4823",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("line", {
                          id: "Line_9",
                          "data-name": "Line 9",
                          x1: "5",
                          y2: "5",
                          fill: "none",
                          stroke: "#fff",
                          strokeLinecap: "round",
                          strokeWidth: "1"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("line", {
                          id: "Line_10",
                          "data-name": "Line 10",
                          x2: "5",
                          y2: "5",
                          transform: "translate(0 5)",
                          fill: "none",
                          stroke: "#fff",
                          strokeLinecap: "round",
                          strokeWidth: "1"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("line", {
                        id: "Line_11",
                        "data-name": "Line 11",
                        x1: "10",
                        transform: "translate(0 5)",
                        fill: "none",
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeWidth: "1"
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                      id: "Rectangle_5661",
                      "data-name": "Rectangle 5661",
                      transform: "translate(0 44) rotate(-90)",
                      fill: "none",
                      stroke: "#fff",
                      strokeWidth: "1",
                      strokeDasharray: "1 140",
                      opacity: "0",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("rect", {
                        width: "44",
                        height: "44",
                        rx: "22",
                        stroke: "none"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("rect", {
                        x: "0.5",
                        y: "0.5",
                        width: "43",
                        height: "43",
                        rx: "21.5",
                        fill: "none"
                      })]
                    })]
                  })
                })]
              })
            })
          })
        })
      }) : '', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
        className: "feature-box-container",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            className: 'boxr',
            children: [feature_box && feature_box.length > 0 && (feature_box === null || feature_box === void 0 ? void 0 : feature_box.map(function (e) {
              var _e$data15, _e$data16, _e$data17, _e$data18, _e$data19;

              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                className: 'feature-box-container_item',
                md: 3,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                  className: "single-item-wrapper",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_9___default()), {
                    href: e === null || e === void 0 ? void 0 : (_e$data15 = e.data) === null || _e$data15 === void 0 ? void 0 : _e$data15.subtitle,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("a", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
                        className: "content",
                        children: [(e === null || e === void 0 ? void 0 : (_e$data16 = e.data) === null || _e$data16 === void 0 ? void 0 : _e$data16.short_desc) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("p", {
                          className: 'split-up',
                          children: e === null || e === void 0 ? void 0 : (_e$data17 = e.data) === null || _e$data17 === void 0 ? void 0 : _e$data17.short_desc
                        }), (e === null || e === void 0 ? void 0 : (_e$data18 = e.data) === null || _e$data18 === void 0 ? void 0 : _e$data18.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("h3", {
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("span", {
                            className: 'split-up',
                            children: e === null || e === void 0 ? void 0 : (_e$data19 = e.data) === null || _e$data19 === void 0 ? void 0 : _e$data19.title
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "44",
                            height: "44",
                            viewBox: "0 0 44 44",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                              id: "Circle",
                              transform: "translate(16429 -2014)",
                              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                                id: "Rectangle_492",
                                "data-name": "Rectangle 492",
                                transform: "translate(-16429 2014)",
                                fill: "none",
                                stroke: "#c6c6c6",
                                strokeWidth: "1",
                                opacity: "0.5",
                                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("rect", {
                                  width: "44",
                                  height: "44",
                                  rx: "22",
                                  stroke: "none"
                                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("rect", {
                                  x: "0.5",
                                  y: "0.5",
                                  width: "43",
                                  height: "43",
                                  rx: "21.5",
                                  fill: "none"
                                })]
                              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                                id: "Group_4824",
                                "data-name": "Group 4824",
                                transform: "translate(-17065.5 434.5)",
                                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                                  id: "Group_4823",
                                  "data-name": "Group 4823",
                                  transform: "translate(11 4)",
                                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("line", {
                                    id: "Line_9",
                                    "data-name": "Line 9",
                                    x2: "5",
                                    y2: "5",
                                    transform: "translate(647.5 1592.5)",
                                    fill: "none",
                                    stroke: "#3c3c3b",
                                    strokeLinecap: "round",
                                    strokeWidth: "1"
                                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("line", {
                                    id: "Line_10",
                                    "data-name": "Line 10",
                                    x1: "5",
                                    y2: "5",
                                    transform: "translate(647.5 1597.5)",
                                    fill: "none",
                                    stroke: "#3c3c3b",
                                    strokeLinecap: "round",
                                    strokeWidth: "1"
                                  })]
                                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("line", {
                                  id: "Line_11",
                                  "data-name": "Line 11",
                                  x2: "10",
                                  transform: "translate(653.5 1601.5)",
                                  fill: "none",
                                  stroke: "#3c3c3b",
                                  strokeLinecap: "round",
                                  strokeWidth: "1"
                                })]
                              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                                id: "Rectangle_5661",
                                "data-name": "Rectangle 5661",
                                transform: "translate(-16429 2058) rotate(-90)",
                                fill: "none",
                                stroke: "#3c3c3b",
                                strokeWidth: "1",
                                strokeDasharray: "1 140",
                                opacity: "0",
                                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("rect", {
                                  width: "44",
                                  height: "44",
                                  rx: "22",
                                  stroke: "none"
                                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("rect", {
                                  x: "0.5",
                                  y: "0.5",
                                  width: "43",
                                  height: "43",
                                  rx: "21.5",
                                  fill: "none"
                                })]
                              })]
                            })
                          })]
                        })]
                      })
                    })
                  })
                })
              });
            })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
              className: 'feature-box-container_item',
              md: 3,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                className: "single-item-wrapper last",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_9___default()), {
                  href: '/search',
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("a", {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                      className: "content",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "60",
                        height: "60",
                        viewBox: "0 0 60 60",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                          id: "Group_15329",
                          "data-name": "Group 15329",
                          transform: "translate(6 6.002)",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                            id: "Ellipse_448",
                            "data-name": "Ellipse 448",
                            transform: "translate(-6 -6.002)",
                            fill: "none",
                            stroke: "#fff",
                            strokeWidth: "1",
                            opacity: "0.5",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("circle", {
                              cx: "30",
                              cy: "30",
                              r: "30",
                              stroke: "none"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("circle", {
                              cx: "30",
                              cy: "30",
                              r: "29.5",
                              fill: "none"
                            })]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                            id: "Group_14964",
                            "data-name": "Group 14964",
                            transform: "translate(12.561 12.557)",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("path", {
                              id: "Path_5781",
                              "data-name": "Path 5781",
                              d: "M18.84,10.42A8.42,8.42,0,1,1,10.42,2,8.421,8.421,0,0,1,18.84,10.42Z",
                              transform: "translate(-2 -2)",
                              fill: "none",
                              stroke: "#fff",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              strokeWidth: "2"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("line", {
                              id: "Line_3560",
                              "data-name": "Line 3560",
                              x1: "5.267",
                              y1: "5.288",
                              transform: "translate(16.939 16.941)",
                              fill: "none",
                              stroke: "#fff",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              strokeWidth: "2"
                            })]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("g", {
                            id: "Ellipse_601",
                            "data-name": "Ellipse 601",
                            transform: "translate(-6 -6.002)",
                            fill: "none",
                            stroke: "#fff",
                            strokeWidth: "1",
                            strokeDasharray: "0 520",
                            opacity: "0",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("circle", {
                              cx: "30",
                              cy: "30",
                              r: "30",
                              stroke: "none"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("circle", {
                              cx: "30",
                              cy: "30",
                              r: "29.5",
                              fill: "none"
                            })]
                          })]
                        })
                      })
                    })
                  })
                })
              })
            })]
          })
        })
      })]
    })
  });
};

var StyledBanner = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "Banner__StyledBanner",
  componentId: "sc-w7z3q3-0"
})(["height:120vh;position:relative;opacity:1 !important;.swiper-button-prev,.swiper-button-next,.swiper-pagination,.mobile{display:none;}.swiper-slide{overflow:hidden;}.swiper-pagination{display:none;}.swiper-button-disabled{opacity:0.5 !important;}.global-image{transition:clipPath .8s cubic-bezier(.29,.73,.45,1),border-color 3.6s linear,-webkit-clipPath .8s cubic-bezier(.29,.73,.45,1);will-change:clipPath;overflow:hidden;-webkit-clipPath:polygon(0 0,100% 0,100% 100%,0 100%);clipPath:polygon(0 0,100% 0,100% 100%,0 100%);}.swiper-slide-active,.swiper-slide-visible{.global-image{clipPath:polygon(0 0,100% 0,100% 100%,0 100%);}.slide-inner{img{height:120vh !important;@media (max-width:767px){height:100% !important;}}}}.swipper-navigation-slider-custom{display:flex;position:absolute;left:0;right:0;bottom:200px;min-height:75px;text-align:left;margin:0 auto;padding-left:", "px;padding-right:", "px;justify-content:space-between;gap:15px;flex-direction:row;.slide-inner-item{width:100%;position:relative;background:transparent !important;padding:20px 0px 0;cursor:pointer;@media (min-width:1536px){padding-right:15px;}span{font-size:20px;font-weight:500;color:#FFFFFF;line-height:28px;}&:after{content:'';position:absolute;left:0;right:0;top:0;height:4px;background:#978c21;width:0;transition:1s all cubic-bezier(.25,.74,.22,.99);opacity:0;}&:hover{&:after{width:100%;opacity:1;}}&:before{content:'';background:transparent !important;position:absolute;left:0;right:0;bottom:0;top:0;z-index:99;}&.active{&:after{width:100%;opacity:1;}}}}.feature-box-container{position:absolute;left:0;right:0;bottom:-110px;z-index:999;width:calc(100% - 30px);margin:0 auto;.col-md-3{padding:0;}.single-item-wrapper{background:white;border-right:1px solid rgba(198,198,198,0.5);height:100%;&.last{background:#978c21;height:100%;display:flex;align-items:center;justify-content:center;border-right:none !important;a{width:100%;text-align:left;.content{align-items:center;justify-content:center;}svg{#Ellipse_601{transition:1s all cubic-bezier(.25,.74,.22,.99);}}@keyframes dash{from{stroke-dashoffset:0;}to{stroke-dashoffset:550px;}}&:hover{}}}a{padding:40px 40px 45px;display:block;height:100%;.content{z-index:4;display:flex;align-items:flex-start;justify-content:space-between;flex-direction:column;width:100%;height:100%;p{color:#C6C6C6;font-size:16px;font-weight:500;line-height:24px;margin-bottom:40px;}h3{margin:0 0 0px;color:#3C3C3B;font-family:\"Avenir Heavy\";font-size:28px;letter-spacing:-1px;line-height:36px;transition:1s all cubic-bezier(.25,.74,.22,.99);position:relative;display:flex;justify-content:space-between;width:100%;}}svg{#Rectangle_5661{transition:1s all cubic-bezier(.25,.74,.22,.99);}}&:hover{h3{color:", ";}svg{#Rectangle_5661{opacity:1;stroke-dasharray:140px;}}}}}}.slide-inner{position:relative;height:120vh;.container{position:absolute;left:0;right:0;top:calc(50% - 10vh);transform:translateY(-50%);z-index:2;}.global-image{&:after{content:'';position:absolute;left:0;right:0;bottom:0;top:0;z-index:1;background:linear-gradient(to right,rgba(0,0,0,0.4),rgba(0,0,0,0));}}&__info{position:relative;overflow:hidden;@media (min-width:1024px){width:70%;}h2{font-size:60px;line-height:70px;margin:0 0 30px 0;font-weight:500;color:white;}h1{font-size:60px;line-height:70px;margin:0 0 30px 0;font-weight:500;color:white;}.dc-btn{position:relative;}}}.navigation{position:absolute;right:", "px;top:calc(50% - 10vh);transform:translateY(-50%);display:inline-block;z-index:1;ul{display:flex;flex-direction:column;li{cursor:pointer;&:first-child{margin-bottom:20px;margin-right:0;}svg{path,#Rectangle_5661{transition:all 1s cubic-bezier(.25,.74,.22,.99);}}&:hover{svg{#Rectangle_5661{opacity:1;stroke-dasharray:140px;}path{stroke:", ";}}}}}}@media (min-width:1550px){.slide-inner{&__info{position:relative;overflow:hidden;h2{font-size:80px;line-height:100px;}.dc-btn{a{font-size:22px;line-height:33px;}}}}.swipper-navigation-slider-custom{bottom:300px;}.feature-box-container{bottom:-150px;}.feature-box-container{.single-item-wrapper{min-height:300px;.content{min-height:250px;}}}}@media (max-width:992px){.swipper-navigation-slider-custom{bottom:250px;}}@media (max-width:992px) and (min-width:768px){height:100vh;.swipper-navigation-slider-custom{bottom:60px;.swiper-initialized{padding-right:30%;}}.slide-inner{height:100vh;.container{top:45%;}}.feature-box-container{display:none;position:relative;left:0;right:0;bottom:200px;z-index:999;width:calc(100% - 30px);margin:0 auto;.single-item-wrapper a .content{align-items:flex-start;}.feature-box-container_item:last-child{order:1;flex:0 0 100%;max-width:100%;}.feature-box-container_item:first-child{order:2;flex:0 0 100%;max-width:100%;.single-item-wrapper{border-right:none;border-bottom:1px solid rgba(198,198,198,0.5);}}.feature-box-container_item:nth-of-type(2){order:3;flex:0 0 50%;max-width:50%;}.feature-box-container_item:nth-of-type(3){order:4;flex:0 0 50%;max-width:50%;.single-item-wrapper{border-right:none;}}}}@media (max-width:767px){height:100vh;.mobile{display:block;}.slide-inner{height:100vh;.container{top:unset;transform:unset;bottom:40%;}&__info{position:relative;overflow:hidden;h2{font-size:40px;line-height:50px;margin:0 0 30px 0;font-weight:500;color:white;}h1{font-size:40px;line-height:50px;margin:0 0 30px 0;font-weight:500;color:white;}.dc-btn{margin-top:30px;}}}.swipper-navigation-slider-custom{padding-left:15px !important;padding-right:15px !important;bottom:30px;.swiper-initialized{padding-right:30%;}}.scrollTo{left:15px;right:unset;display:inline-block;bottom:20px;transform:translateX(0);}.navigation{display:none;}.feature-box-container{display:none;position:relative;bottom:150px;.feature-box-container_item{&:first-child{order:2;}&:nth-of-type(2){order:3;}&:nth-of-type(3){order:4;}&:last-child{order:1;.content{}}}.single-item-wrapper{border-right:none;border-bottom:1px solid rgba(198,198,198,0.5);.content{align-items:flex-start !important;}&.last{border:none;.content{align-items:center !important;}}}.container{padding:0;}}}"], function (props) {
  return props.offset ? props.offset : '90';
}, function (props) {
  return props.offset ? props.offset : '90';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_19__/* .hover */ .Mr, function (props) {
  return props.offset ? props.offset : '90';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_19__/* .hover */ .Mr);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(Banner));

/***/ }),

/***/ 13810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68777);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Img = function Img(_ref) {
  var src = _ref.src,
      visible = _ref.visible,
      speed = _ref.speed,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  // const smoother = useContext(SmootherContext);
  //
  // useEffect(() => {
  //     smoother.effects("img", {speed: "auto"})
  // }, [])
  var DefaultBanner = '/images/static/blurbg.svg';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledImg, {
    className: "global-image  ",
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: src && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
      alt: alt || 'Shanta Securities Limited',
      src: src || DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ImgP__StyledImg",
  componentId: "sc-3jyf6w-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";overflow:hidden;img{width:100%;height:120svh;object-fit:", ";position:absolute;top:0;left:0;right:0;bottom:0;will-change:transform;@media(max-width:767px){height:100% !important;}}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 68893:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9846:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 13390:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);